import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { OrdersPaths } from '@/shared/lib/react-router';

import { useReconciliationFile } from './reconciliation-file.store';

export const useRedirectIfNoReconciliationData = () => {
  const reconciliationFile = useReconciliationFile();
  const navigate = useNavigate();

  const shouldRedirect = !reconciliationFile;

  useEffect(() => {
    if (shouldRedirect) {
      navigate(OrdersPaths.ROOT, { replace: true });
    }
  }, [shouldRedirect, navigate]);

  return shouldRedirect;
};
